import * as types from 'constants/actionTypes'

export const receivePlans = (plans) => ({ type: types.RECEIVE_PLANS, plans })

export const updatePlan = (id, plan) => ({ type: types.UPDATE_PLAN, id, plan })

export const removePlan = (id) => ({ type: types.REMOVE_PLAN, id })



// WEBPACK FOOTER //
// ./src/actions/plansAC.js